import { useFetchPublishedDocument } from '@common/hooks/useFetchPublishedDocument';
import { useFetchDocumentMetadata } from '@common/hooks/useFetchDocumentMetadata';
import { DocumentType, DocumentExtensionType } from '@common/types';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router';

export const PrintPublishedDocument = ({
  isAdmin = false
}: {
  isAdmin?: boolean;
}) => {

  const {documentId, version, documentType} = useParams();

  const documentTypeForHtml = documentType === DocumentType.Pil ? DocumentType.Epil : documentType;

  const { data: htmlData } = useFetchPublishedDocument(
    false,
    documentId,
    version,
    documentTypeForHtml as DocumentType,
    DocumentExtensionType.Html
  );

  const { documentMetadata } = useFetchDocumentMetadata(
    documentId as unknown as number,
    version as unknown as number,
    documentTypeForHtml as DocumentType,
  );

  const [htmlDataExpanded, setHtmlDataExpanded] = useState('');

  useEffect(() => {
    const isHtmlDataReadyToShow = documentMetadata &&
      (isAdmin || documentType !== DocumentType.Smpc || documentMetadata.hasTvtFiles) &&
      !!htmlData;

    if (isHtmlDataReadyToShow) {
      const expandedHtml = htmlData.replaceAll("<details", "<details open=\"\"");
      setHtmlDataExpanded(expandedHtml);
    }

    document.head.innerHTML = '';

    const printStylesheet = document.createElement('link');
    printStylesheet.rel = 'stylesheet';
    printStylesheet.href = '/print.css';
    printStylesheet.type = 'text/css';
    document.head.appendChild(printStylesheet);

    document.title = `${documentType}.${documentId}.v.${version}`;

    if (isHtmlDataReadyToShow) {
      setTimeout(() => {
        window.print();
      }, 500);
    }

    return () => {
      if (document.head.contains(printStylesheet)) {
        document.head.removeChild(printStylesheet);
      }
    };
  }, [htmlData, documentMetadata, documentType, documentId, version, isAdmin]);
  
  return <div id="html-content" dangerouslySetInnerHTML={{ __html: htmlDataExpanded }} />;
};
